import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_PIGGYBANK } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Piggybank',
        name: 'Piggybank',
        icon: 'fas fa-piggy-bank'
    },
    {
        parent: 'Multiplayer.Piggybank',
        key: 'Item',
        name: 'Item',
        icon: 'fas fa-leaf',
        route: { name: ROUTE_NAME_PIGGYBANK.ITEM.INDEX }
    },
    {
        parent: 'Multiplayer.Piggybank',
        key: 'Boost',
        name: 'Boost',
        icon: 'fas fa-syringe',
        route: { name: ROUTE_NAME_PIGGYBANK.BOOST }
    }
]);

export default registerRouteForModule(router);
